import { render, staticRenderFns } from "./InternalTrade.vue?vue&type=template&id=11d3fc88&scoped=true&"
var script = {}
import style0 from "./InternalTrade.vue?vue&type=style&index=0&id=11d3fc88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d3fc88",
  null
  
)

export default component.exports